import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { genreNameMap } from '@/mocks/genres';

type MovieCardProps = {
  movie: Movie;
};

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-primary-900 pt-[150%]">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 电影海报`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950">
          {movie.title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300" />
          <span>{movie.region}</span>
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {movie.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {genreNameMap[genre] ?? genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}